import React, { Fragment } from 'react';
import Lightbox from 'react-images';

const LightboxImages = props => (
    <Fragment>
        <div className="product-images">

            <div className="product-detail__image-container">
                <div className="product__tags product__tags--lower">
                    {props.badges.map((badge, index) => (
                        badge.className !== 'product__badge--upper-lower' &&
                        <span className={`product-detail__label ${badge.className}`} key={index} />
                    ))}
                </div>

                <figure className="product-detail__figure">
                    <a data-src={props.images[0].src} itemProp="url" onClick={() => props.onClickThumbnail(0)} className="product-image">
                        <img className="product-detail__image--main" itemProp="image" src={props.thumbnails[0].src} />
                    </a>
                </figure>

            </div>

            {props.images.length > 1 && 
                <div className="product-detail__slider">
                    <ul className={"product-detail__image-container--thumbnails " + (props.images.length <= 4 ? 'full-width' : '')}>
                        {props.images.map((image, index) => (
                            index > 0 &&
                            <li className="product-detail__thumbnails" key={index}>
                                <a className="product-detail__thumbnails-link" data-src={image.src} itemProp="url" onClick={() => props.onClickThumbnail(index)}>
                                    <img className="product-detail__image--alter" itemProp="image" src={props.thumbnails[index].src} />
                                </a>
                            </li>
                        ))}
                    </ul>
                    {props.images.length > 4 &&
                        <button className="product__image--arrow left" onClick={(e) => props.swipeImage(e)} />
                    }
                    {props.images.length > 4 &&
                        <button className="product__image--arrow right" onClick={(e) => props.swipeImage(e)} />
                    }
                </div>
            }
        </div>
        <Lightbox
            showThumbnails={true}
            showImageCount={false}
            {...props}
        />
    </Fragment>
)

export default LightboxImages;